<div class="row mb-4">
    <div class="col-sm-12 mx-auto">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-12 mb-4">Create WPPSI</h4>
                    <form #theForm="ngForm" (ngSubmit)="submitForm(formGroup)" novalidate class="col-12">
                        <div [formGroup]="formGroup">
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Type</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-check">
                                        <input class="form-check-input" formControlName="type" type="radio" value="visual-spatial-index" id="type-pre" required>
                                        <label class="form-check-label" for="type-pre">
                                            Visual Spatial
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" formControlName="type" type="radio" value="processing-speed-index" id="type-post" required>
                                        <label class="form-check-label" for="type-post">
                                            Processing Speed
                                        </label>
                                    </div>
                                    <div class="text-danger" *ngIf="formGroup.get('type')?.invalid && (theForm.submitted || formGroup.get('type')?.touched)">
                                        <small *ngIf="formGroup.get('type')?.errors?.required">Select type</small>
                                        <small *ngIf="formGroup.get('type')?.errors?.serverError">{{formGroup.get('type')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Point</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="number" formControlName="point" class="form-control" [class.is-invalid]="formGroup.get('point')?.invalid && (theForm.submitted || formGroup.get('point')?.touched)" placeholder="Type point" required>
                                    <div class="text-danger" *ngIf="formGroup.get('point')?.invalid && (theForm.submitted || formGroup.get('point')?.touched)">
                                        <small *ngIf="formGroup.get('point')?.errors?.required">Type point</small>
                                        <small *ngIf="formGroup.get('point')?.errors?.serverError">{{formGroup.get('point')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Question Image</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="input-group">
                                        <input class="form-control" placeholder="Choose file" [value]="question?.file?.name" readonly (click)="inputQuestion.click()" [attr.disabled]="loading.status ? 'disabled' : null">
                                        <button type="button" class="btn btn-outline-primary" (click)="inputQuestion.click()" [attr.disabled]="loading.status ? 'disabled' : null">
                                            <i class="material-icons">search</i>
                                        </button>
                                        <input class="d-none" #inputQuestion accept=".jpg,.jpeg,.png" (change)="fileHandler.handle($event, question, 'image/png,image/jpg,image/jpeg')" type="file">
                                    </div>
                                    <small>FileType: png,jpg; {{formGroup.get('type')?.value=='visual-spatial-index'?'; resolution: 400x400 pixel':null}}</small>
                                </div>
                            </div>
                            <div *ngIf="formGroup.get('type')?.value=='visual-spatial-index'" class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Grid size</label>
                                </div>
                                <div class="col-md-8">
                                    <select formControlName="grid" class="form-select" [class.is-invalid]="formGroup.get('grid')?.invalid && (theForm.submitted || formGroup.get('grid')?.touched)" required>
                                        <option value="2">2x2</option>
                                        <option value="3">3x3</option>
                                        <option value="4">4x4</option>
                                    </select>
                                    <div class="text-danger" *ngIf="formGroup.get('grid')?.invalid && (theForm.submitted || formGroup.get('grid')?.touched)">
                                        <small *ngIf="formGroup.get('grid')?.errors?.required">Select grid size</small>
                                        <small *ngIf="formGroup.get('grid')?.errors?.serverError">{{formGroup.get('grid')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label>Voice</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="input-group">
                                        <input class="form-control" placeholder="Choose file" [value]="voice?.view ?? ''" readonly (click)="inputVoice.click()" [attr.disabled]="loading.status ? 'disabled' : null">
                                        <button type="button" class="btn btn-outline-primary" (click)="inputVoice.click()" [attr.disabled]="loading.status ? 'disabled' : null">
                                            <i class="material-icons">search</i>
                                        </button>
                                        <input class="d-none" #inputVoice accept=".mp3" (change)="fileHandler.handle($event, voice, 'audio/mpeg,audio/x-mpeg3,audio/mpeg3', (0.5))" type="file">
                                    </div>
                                    <small>FileType: mp3, size: 500KB</small>
                                </div>
                            </div>
                            <div *ngIf="formGroup.get('type')?.value=='processing-speed-index'" class="row">
                                <div class="col-12 mb-3">
                                    <div class="fs-5">Answer choice</div>
                                </div>
                                <div class="col-12">
                                    <table class="table table-borderless">
                                        <thead>
                                            <tr>
                                                <th class="text-center">
                                                    #
                                                </th>
                                                <th>
                                                    Image<br>
                                                    <small class="fw-normal">Filetype: png,jpg; resolution: 100x100 pixel</small>
                                                </th>
                                                <th>
                                                    Is correct answer?<br>
                                                    <small class="fw-normal">Mark if its true</small>
                                                </th>
                                                <th>
                                                    Remove
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let d of details;index as i">
                                                <td class="text-center">
                                                    {{i+1}}
                                                </td>
                                                <td>
                                                    <div class="d-flex align-items-center">
                                                        <div *ngIf="details[i].image?.view" class="border me-2 p-1 rounded position-relative">
                                                            <img src="{{details[i].image.view}}" style="height:32px;width:auto" />
                                                        </div>
                                                        <div>
                                                            <button type="button" class="btn btn-sm btn-outline-primary" (click)="browseImage(i);" [attr.disabled]="loading.status ? 'disabled' : null">
                                                                <i class="material-icons fs-6">search</i>
                                                            </button>
                                                            <input class="d-none" id="input-image-{{i}}" accept=".png,.jpg" (change)="fileHandler.handle($event, details[i].image, 'image/png,image/jpg,image/jpeg')" type="file">
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-check">
                                                        <input class="form-check-input" [attr.disabled]="loading.status || !details[i].image?.view ? 'disabled': null" type="checkbox" (click)="isTrue($event, i)" [checked]="d.is_true">
                                                    </div>
                                                </td>
                                                <td>
                                                    <button [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-sm btn-danger" (click)="removeDetails(i)">
                                                        <i class="material-icons fs-6">delete</i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12" *ngIf="details.length<20">
                                    <button (click)="addDetails()" [attr.disabled]="loading.status ? 'disabled' : null" type="button" class="btn btn-secondary">
                                        Add choice
                                    </button>
                                </div>
                            </div>
                            <!-- <div *ngIf="formGroup.get('type')?.value=='processing-speed-index'" class="row">
                                <div class="col-12">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="text-center">
                                                    #
                                                </th>
                                                <th>
                                                    Question<br>
                                                    <small class="fw-normal">Filetype: png,jpg</small>
                                                </th>
                                                <th>
                                                    Answer choice<br>
                                                    <small class="fw-normal">Filetype: png,jpg</small>
                                                </th>
                                                <th class="text-center">
                                                    Remove
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let d of details;index as i">
                                                <td class="text-center">
                                                    {{i+1}}
                                                </td>
                                                <td>
                                                    <div class="d-flex align-items-center">
                                                        <div *ngIf="d.image?.view" class="border me-2 p-1 rounded position-relative">
                                                            <img src="{{d.image.view}}" style="height:50px;width:auto" />
                                                        </div>
                                                        <div>
                                                            <button type="button" class="btn btn-sm btn-outline-primary" (click)="browseImage(i);" [attr.disabled]="loading.status ? 'disabled' : null">
                                                                <i class="material-icons fs-6">search</i>
                                                            </button>
                                                            <input class="d-none" id="input-image-{{i}}" accept=".png,.jpg" (change)="fileHandler.handle($event, d.image, 'image/png,image/jpg,image/jpeg')" type="file">
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div *ngFor="let s of d.subdetails;index as x;" class="d-flex align-items-center mb-2">
                                                        <div class="d-flex align-items-center" style="width:40%;">
                                                            <div *ngIf="s.image?.view" class="border me-2 p-1 rounded position-relative">
                                                                <img src="{{s.image.view}}" style="height:32px;width:auto" />
                                                            </div>
                                                            <div>
                                                                <button type="button" class="btn btn-sm btn-outline-primary" (click)="browseSubImage(i, x);" [attr.disabled]="loading.status ? 'disabled' : null">
                                                                    <i class="material-icons fs-6">search</i>
                                                                </button>
                                                                <input class="d-none" id="input-subimage-{{i}}-{{x}}" accept=".png,.jpg" (change)="fileHandler.handle($event, s.image, 'image/png,image/jpg,image/jpeg')" type="file">
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div class="form-check">
                                                                <input class="form-check-input" id="is-true-{{i}}-{{x}}" [attr.disabled]="loading.status || !s.image?.view ? 'disabled': null" type="checkbox" (click)="isTrue($event, i, x)" [checked]="s.is_true">
                                                                <label class="small" for="is-true-{{i}}-{{x}}">Is correct answer?</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <button [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-sm btn-danger" (click)="removeDetails(i)">
                                                        <i class="material-icons fs-6">delete</i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12" *ngIf="details.length<7">
                                    <button (click)="addDetails()" [attr.disabled]="loading.status ? 'disabled' : null" type="button" class="btn btn-secondary">
                                        Add choice
                                    </button>
                                </div>
                            </div> -->
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-top pt-4 mt-4">
                            <div>
                                <div class="form-check">
                                    <input class="form-check-input" [(ngModel)]="stayPage" [ngModelOptions]="{standalone: true}" type="checkbox" id="stayPage" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <label class="form-check-label" for="stayPage">
                                        Stay on this page
                                    </label>
                                </div>
                            </div>
                            <div class="text-end">
                                <button type="button" class="btn btn-secondary" (click)="back();" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">close</i> &nbsp;
                                    Cancel
                                </button>
                                &nbsp;
                                <button type="submit" class="btn btn-primary" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">save</i> &nbsp;
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
